(function () {
  function parseJsonScript(id) {
    var node = document.getElementById(id);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error('Invalid Muskel Wasser config:', id, error);
      return null;
    }
  }

  function stripHtml(value) {
    return String(value || '').replace(/<[^>]*>/g, '').trim();
  }

  function formatMoney(cents, moneyFormat) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return stripHtml(window.Shopify.formatMoney(cents, moneyFormat));
    }
    var amount = ((Number(cents) || 0) / 100).toFixed(2);
    var commaAmount = amount.replace('.', ',');
    var format = moneyFormat || '{{amount}}';
    return stripHtml(format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, commaAmount)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, commaAmount.split(',')[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amount.split('.')[0])
      .replace(/\{\{\s*amount\s*\}\}/g, amount));
  }

  var globalConfig = parseJsonScript('mwasser-global-config') || {};
  var mainCheckoutLine = {
    sourceProperty: '_mwasser_main_checkout',
    tokenProperty: '_mwasser_checkout_token',
    sessionKey: 'mwasserMainCheckoutToken'
  };
  var customCheckoutLine = {
    sourceProperty: '_mwasser_custom_checkout'
  };
  var localePreferenceKey = 'mwasserLocalePreference';
  var germanLocaleCountries = ['DE', 'AT', 'CH', 'LI', 'LU'];

  function getStoredLocalePreference() {
    try {
      return window.localStorage.getItem(localePreferenceKey);
    } catch (error) {
      return '';
    }
  }

  function setStoredLocalePreference(locale) {
    try {
      window.localStorage.setItem(localePreferenceKey, locale);
    } catch (error) {}
  }

  function normalizeLocaleRoot(root) {
    var normalized = root || '/';
    try {
      normalized = new URL(normalized, window.location.origin).pathname;
    } catch (error) {}
    if (normalized.charAt(0) !== '/') normalized = '/' + normalized;
    if (normalized.charAt(normalized.length - 1) !== '/') normalized += '/';
    return normalized;
  }

  function getLocaleRoot(locale) {
    var roots = globalConfig.localeRootUrls || {};
    if (roots[locale]) return normalizeLocaleRoot(roots[locale]);
    if (locale === 'de') return '/';
    return '/' + locale + '/';
  }

  function stripCurrentLocaleRoot(path) {
    var roots = globalConfig.localeRootUrls || {};
    var currentPath = path || '/';
    var candidates = Object.keys(roots).map(function (locale) {
      return normalizeLocaleRoot(roots[locale]);
    }).sort(function (a, b) {
      return b.length - a.length;
    });

    for (var i = 0; i < candidates.length; i += 1) {
      var root = candidates[i];
      var rootWithoutSlash = root.replace(/\/$/, '');
      if (root === '/') continue;
      if (currentPath === rootWithoutSlash) return '';
      if (currentPath.indexOf(root) === 0) return currentPath.slice(root.length);
    }

    return currentPath.replace(/^\/+/, '');
  }

  function getAutoLocaleTarget() {
    var country = String(globalConfig.currentCountry || '').toUpperCase();
    if (country) {
      return germanLocaleCountries.indexOf(country) !== -1 ? 'de' : 'en';
    }

    var browserLanguages = navigator.languages && navigator.languages.length
      ? navigator.languages
      : [navigator.language || ''];
    var hasGermanBrowserLanguage = browserLanguages.some(function (language) {
      return String(language || '').toLowerCase().indexOf('de') === 0;
    });
    return hasGermanBrowserLanguage ? 'de' : 'en';
  }

  function shouldSkipLocaleAutoSelect() {
    if (!globalConfig.localeAutoSelect || globalConfig.designMode || (window.Shopify && window.Shopify.designMode)) return true;
    if (getStoredLocalePreference()) return true;

    var path = window.location.pathname || '/';
    return path.indexOf('/checkout') !== -1
      || path.indexOf('/checkouts') !== -1
      || path.indexOf('/account') !== -1
      || path.indexOf('/customer_authentication/login') !== -1
      || path.indexOf('/challenge') !== -1;
  }

  function autoSelectLocale() {
    if (shouldSkipLocaleAutoSelect()) return;

    var targetLocale = getAutoLocaleTarget();
    var availableRoots = globalConfig.localeRootUrls || {};
    if (Object.keys(availableRoots).length && !availableRoots[targetLocale]) return;
    if (globalConfig.currentLocale === targetLocale) return;

    var targetRoot = getLocaleRoot(targetLocale);
    var contentPath = stripCurrentLocaleRoot(window.location.pathname || '/');
    var targetPath = targetRoot + contentPath.replace(/^\/+/, '');
    var targetUrl = targetPath + window.location.search + window.location.hash;
    var currentUrl = window.location.pathname + window.location.search + window.location.hash;
    if (targetUrl !== currentUrl) {
      window.location.replace(targetUrl);
    }
  }

  function bindLocalizationPreference() {
    document.querySelectorAll('.mw-header__lang-form').forEach(function (form) {
      if (form.dataset.mwLocalePreferenceBound === 'true') return;
      form.dataset.mwLocalePreferenceBound = 'true';
      form.addEventListener('submit', function () {
        var input = form.querySelector('input[name="language_code"]');
        if (input && input.value) setStoredLocalePreference(input.value);
      });
    });
  }

  function updateHeaderCart(cart, texts, moneyFormat) {
    var cartItemsNode = document.querySelector('.mw-header__cart-items');
    var cartTotalNode = document.querySelector('.mw-header__cart-total');
    if (!cartItemsNode || !cartTotalNode || !cart) return;

    var itemCount = Number(cart.item_count) || 0;
    cartItemsNode.textContent = itemCount + ' ' + (itemCount === 1 ? texts.one : texts.other);
    cartTotalNode.textContent = formatMoney(cart.total_price || 0, moneyFormat);
  }

  function getStoredMainCheckoutToken() {
    try {
      return window.sessionStorage.getItem(mainCheckoutLine.sessionKey);
    } catch (error) {
      return null;
    }
  }

  function clearStoredMainCheckoutToken() {
    try {
      window.sessionStorage.removeItem(mainCheckoutLine.sessionKey);
    } catch (error) {}
  }

  function setStoredMainCheckoutToken(token) {
    try {
      window.sessionStorage.setItem(mainCheckoutLine.sessionKey, token);
    } catch (error) {}
  }

  function returnedFromCheckout(event) {
    var navigationEntries = typeof performance !== 'undefined' && typeof performance.getEntriesByType === 'function'
      ? performance.getEntriesByType('navigation')
      : [];
    var navigationType = navigationEntries.length ? navigationEntries[0].type : '';
    var referrer = document.referrer || '';

    return event.persisted || navigationType === 'back_forward' || referrer.indexOf('/checkout') !== -1 || referrer.indexOf('/checkouts') !== -1;
  }

  async function fetchJson(url, options) {
    var response = await fetch(url, options || {});
    if (!response.ok) throw new Error('Request failed: ' + url);
    return response.json();
  }

  async function changeCartLine(changeUrl, key, quantity) {
    return fetchJson(changeUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }

  async function cleanupMainCheckoutLine(event) {
    var token = getStoredMainCheckoutToken();
    if (!token || !returnedFromCheckout(event) || !globalConfig.cartUrl || !globalConfig.changeUrl) return;

    try {
      var cart = await fetchJson(globalConfig.cartUrl, {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      var mainItems = (cart.items || []).filter(function (item) {
        var properties = item.properties || {};
        return properties[mainCheckoutLine.sourceProperty] === 'true'
          && properties[mainCheckoutLine.tokenProperty] === token;
      });
      var latestCart = cart;

      for (var i = 0; i < mainItems.length; i += 1) {
        latestCart = await changeCartLine(globalConfig.changeUrl, mainItems[i].key, 0);
      }

      clearStoredMainCheckoutToken();
      updateHeaderCart(latestCart, {
        one: globalConfig.cartItemOne,
        other: globalConfig.cartItemOther
      }, globalConfig.moneyFormat);

      if (window.location.pathname.indexOf('/cart') !== -1 && mainItems.length > 0) {
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function cleanupMainCheckoutLinesOnCart() {
    if (cartMainCheckoutCleanupStarted || window.location.pathname.indexOf('/cart') === -1 || !globalConfig.cartUrl || !globalConfig.changeUrl) return;
    cartMainCheckoutCleanupStarted = true;

    try {
      var cart = await fetchJson(globalConfig.cartUrl, {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      var mainItems = (cart.items || []).filter(function (item) {
        var properties = item.properties || {};
        return properties[mainCheckoutLine.sourceProperty] === 'true';
      });
      var latestCart = cart;

      for (var i = 0; i < mainItems.length; i += 1) {
        latestCart = await changeCartLine(globalConfig.changeUrl, mainItems[i].key, 0);
      }

      if (mainItems.length > 0) {
        clearStoredMainCheckoutToken();
        updateHeaderCart(latestCart, {
          one: globalConfig.cartItemOne,
          other: globalConfig.cartItemOther
        }, globalConfig.moneyFormat);
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
    }
  }

  window.addEventListener('pageshow', cleanupMainCheckoutLine);

  var productConfig = null;
  var productInitialized = false;
  var cartInitialized = false;
  var cartMainCheckoutCleanupStarted = false;
  var heroBadgeState = null;
  var headerScrollState = {
    bound: false,
    lastY: Math.max(0, window.scrollY || window.pageYOffset || 0),
    raf: 0,
    forceHiddenUntil: 0,
    forceHiddenTimer: 0
  };

  var nutritionUnits = {
    energy: '',
    fat: ' g',
    fat_sat: ' g',
    carbs: ' g',
    sugars: ' g',
    protein: ' g',
    salt: ' g',
    vit_c: ' mg',
    niacin: ' mg',
    panto: ' mg',
    b6: ' mg',
    biotin: ' mcg',
    b12: ' mcg'
  };

  function fmt(value, unit) {
    if (value === null || value === undefined || value === '') return '';
    return unit ? value + unit : value;
  }

  function fmtPct(value) {
    if (value === null || value === undefined || value === '') return '';
    return value + '%';
  }

  function setText(id, value) {
    var node = document.getElementById(id);
    if (node) node.textContent = value;
  }

  function getVisibleHeaderOffset() {
    var header = document.querySelector('.mw-header');
    if (!header) return 16;
    if (header.classList.contains('is-hidden')) return 16;
    var rect = header.getBoundingClientRect();
    return rect.bottom > 0 ? Math.ceil(rect.bottom) + 16 : 16;
  }

  function forceHideHeader(duration) {
    var header = document.querySelector('.mw-header');
    if (!header) return;

    var hideDuration = Number(duration) || 900;
    headerScrollState.forceHiddenUntil = Date.now() + hideDuration;
    header.classList.add('is-hidden', 'is-force-hidden');

    if (headerScrollState.forceHiddenTimer) {
      window.clearTimeout(headerScrollState.forceHiddenTimer);
    }
    headerScrollState.forceHiddenTimer = window.setTimeout(function () {
      headerScrollState.forceHiddenTimer = 0;
      header.classList.remove('is-force-hidden');
      scheduleHeaderVisibility();
    }, hideDuration);
  }

  function updateHeaderVisibility() {
    var header = document.querySelector('.mw-header');
    if (!header) return;

    var currentY = Math.max(0, window.scrollY || window.pageYOffset || 0);
    var delta = currentY - headerScrollState.lastY;
    var headerHeight = header.offsetHeight || 0;
    var mobileMenuOpen = Boolean(header.querySelector('.mw-header__mobile-menu[open]'));
    var headerHasFocus = Boolean(document.activeElement && header.contains(document.activeElement));
    var nearTop = currentY <= Math.max(24, headerHeight * 0.45);
    var forceHidden = headerScrollState.forceHiddenUntil > Date.now();

    if (forceHidden) {
      header.classList.add('is-hidden', 'is-force-hidden');
      headerScrollState.lastY = currentY;
      return;
    }

    header.classList.remove('is-force-hidden');

    if (nearTop || delta < -6 || mobileMenuOpen || headerHasFocus) {
      header.classList.remove('is-hidden');
    } else if (delta > 6 && currentY > headerHeight) {
      header.classList.add('is-hidden');
    }

    headerScrollState.lastY = currentY;
  }

  function normalizePathname(path) {
    var normalized = path || '/';
    if (normalized.length > 1 && normalized.charAt(normalized.length - 1) === '/') {
      normalized = normalized.slice(0, -1);
    }
    return normalized;
  }

  function getAnchorTargetFromLink(link) {
    if (!link) return null;
    var rawHref = link.getAttribute('href') || '';
    if (rawHref.indexOf('#') === -1) return null;

    try {
      var url = new URL(rawHref, window.location.origin);
      if (url.origin !== window.location.origin) return null;
      if (normalizePathname(url.pathname) !== normalizePathname(window.location.pathname)) return null;
      if (!url.hash || url.hash === '#') return null;

      var id = url.hash.slice(1);
      try {
        id = decodeURIComponent(id);
      } catch (error) {}
      return document.getElementById(id);
    } catch (error) {
      return null;
    }
  }

  function scrollToTargetWithHiddenHeader(target) {
    if (!target) return;

    forceHideHeader(1100);
    var targetTop = window.scrollY + target.getBoundingClientRect().top - getVisibleHeaderOffset();
    var maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top: Math.max(0, Math.min(Math.round(targetTop), maxScroll)),
      behavior: reduceMotion ? 'auto' : 'smooth'
    });
  }

  function bindHeaderAnchorAutoHide(header) {
    header.querySelectorAll('a[href*="#"]').forEach(function (link) {
      if (link.dataset.mwHeaderAnchorBound === 'true') return;
      link.dataset.mwHeaderAnchorBound = 'true';
      link.addEventListener('click', function (event) {
        var target = getAnchorTargetFromLink(link);
        var mobileMenu = link.closest('.mw-header__mobile-menu');

        try {
          window.sessionStorage.setItem('mwasserHeaderHideOnHash', 'true');
        } catch (error) {}

        if (mobileMenu) mobileMenu.open = false;
        forceHideHeader(1100);

        if (!target) return;
        event.preventDefault();
        if (document.activeElement && typeof document.activeElement.blur === 'function') {
          document.activeElement.blur();
        }
        scrollToTargetWithHiddenHeader(target);
        if (window.history && typeof window.history.pushState === 'function') {
          window.history.pushState(null, '', '#' + target.id);
        }
      });
    });
  }

  function hideHeaderForPendingHash() {
    var shouldHide = false;
    try {
      shouldHide = window.sessionStorage.getItem('mwasserHeaderHideOnHash') === 'true';
      window.sessionStorage.removeItem('mwasserHeaderHideOnHash');
    } catch (error) {}

    if (!shouldHide || !window.location.hash) return;
    var target = document.getElementById(window.location.hash.slice(1));
    if (target) {
      window.requestAnimationFrame(function () {
        scrollToTargetWithHiddenHeader(target);
      });
    } else {
      forceHideHeader(1100);
    }
  }

  function scheduleHeaderVisibility() {
    if (headerScrollState.raf) return;
    headerScrollState.raf = window.requestAnimationFrame(function () {
      headerScrollState.raf = 0;
      updateHeaderVisibility();
    });
  }

  function bindAutoHidingHeader() {
    if (headerScrollState.bound) return;
    var header = document.querySelector('.mw-header');
    if (!header) return;

    headerScrollState.bound = true;
    headerScrollState.lastY = Math.max(0, window.scrollY || window.pageYOffset || 0);
    window.addEventListener('scroll', scheduleHeaderVisibility, { passive: true });
    window.addEventListener('resize', scheduleHeaderVisibility, { passive: true });
    document.addEventListener('focusin', scheduleHeaderVisibility);
    header.querySelectorAll('.mw-header__mobile-menu').forEach(function (menu) {
      menu.addEventListener('toggle', scheduleHeaderVisibility);
    });
    bindHeaderAnchorAutoHide(header);
    updateHeaderVisibility();
  }

  function scrollCustomBundleIntoView() {
    var card = document.getElementById('mwasser-custom-card');
    if (!card || !isCustomBundleOpen()) return;

    var targetTop = window.scrollY + card.getBoundingClientRect().top - getVisibleHeaderOffset();
    var maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top: Math.max(0, Math.min(Math.round(targetTop), maxScroll)),
      behavior: reduceMotion ? 'auto' : 'smooth'
    });
  }

  function scheduleCustomBundleScroll() {
    forceHideHeader(1100);
    window.requestAnimationFrame(scrollCustomBundleIntoView);
    window.setTimeout(scrollCustomBundleIntoView, 320);
  }

  function renderNutrition(flavorKey) {
    if (!productConfig || !productConfig.nutrition) return;
    var data = productConfig.nutrition[flavorKey];
    if (!data) return;

    ['nutri-heading', 'vit-heading'].forEach(function (id) {
      var node = document.getElementById(id);
      if (!node) return;
      node.classList.remove('text-primary', 'text-secondary', 'text-tertiary');
      node.classList.add(data.color);
    });

    setText('n-energy-100', fmt(data.energy_100, nutritionUnits.energy));
    setText('n-energy-bottle', fmt(data.energy_bottle, nutritionUnits.energy));
    setText('n-fat-100', fmt(data.fat_100, nutritionUnits.fat));
    setText('n-fat-bottle', fmt(data.fat_bottle, nutritionUnits.fat));
    setText('n-fat-sat-100', fmt(data.fat_sat_100, nutritionUnits.fat_sat));
    setText('n-fat-sat-bottle', fmt(data.fat_sat_bottle, nutritionUnits.fat_sat));
    setText('n-carbs-100', fmt(data.carbs_100, nutritionUnits.carbs));
    setText('n-carbs-bottle', fmt(data.carbs_bottle, nutritionUnits.carbs));
    setText('n-sugars-100', fmt(data.sugars_100, nutritionUnits.sugars));
    setText('n-sugars-bottle', fmt(data.sugars_bottle, nutritionUnits.sugars));
    setText('n-protein-100', fmt(data.protein_100, nutritionUnits.protein));
    setText('n-protein-bottle', fmt(data.protein_bottle, nutritionUnits.protein));
    setText('n-salt-100', fmt(data.salt_100, nutritionUnits.salt));
    setText('n-salt-bottle', fmt(data.salt_bottle, nutritionUnits.salt));

    [
      ['v-c', 'vit_c', nutritionUnits.vit_c],
      ['v-niacin', 'niacin', nutritionUnits.niacin],
      ['v-panto', 'panto', nutritionUnits.panto],
      ['v-b6', 'b6', nutritionUnits.b6],
      ['v-biotin', 'biotin', nutritionUnits.biotin],
      ['v-b12', 'b12', nutritionUnits.b12]
    ].forEach(function (row) {
      var prefix = row[0];
      var key = row[1];
      var unit = row[2];
      setText(prefix + '-100', fmt(data[key + '_100'], unit));
      setText(prefix + '-100-nrv', fmtPct(data[key + '_100_nrv']));
      setText(prefix + '-bottle', fmt(data[key + '_bottle'], unit));
      setText(prefix + '-bottle-nrv', fmtPct(data[key + '_bottle_nrv']));
    });
  }

  function setImageWithFade(image, src) {
    if (!image || !src) return;
    image.style.opacity = '0';
    window.setTimeout(function () {
      image.src = src;
      image.onload = function () {
        image.style.opacity = '1';
      };
    }, 250);
  }

  function renderFlavorTags(tagsNode, tags) {
    tagsNode.replaceChildren();
    (tags || []).forEach(function (tag, index) {
      if (index > 0) {
        var separator = document.createElement('span');
        separator.className = 'mw-flavor-separator';
        separator.setAttribute('aria-hidden', 'true');
        separator.textContent = '|';
        tagsNode.appendChild(separator);
      }
      var tagNode = document.createElement('span');
      tagNode.className = 'mw-flavor-tag';
      tagNode.textContent = tag;
      tagsNode.appendChild(tagNode);
    });
  }

  function switchFlavor(button) {
    if (!productConfig || !button) return;
    var selected = button.getAttribute('data-flavor-key') || 'berry';
    var flavorData = productConfig.flavors || {};
    var data = flavorData[selected];
    if (!data) return;

    var mainImg = document.getElementById('main-product-image');
    var mainFrame = document.getElementById('main-product-frame');
    var designImg = document.getElementById('design-bottle-image');
    var designFrame = document.getElementById('design-product-frame');
    var backLeft = document.querySelector('#design-bottle-back-left img');
    var backRight = document.querySelector('#design-bottle-back-right img');
    var backLeftFrame = document.getElementById('design-bottle-back-left');
    var backRightFrame = document.getElementById('design-bottle-back-right');
    var frontFrame = document.getElementById('design-bottle-front');
    var tagsNode = document.getElementById('dynamic-flavor-tags');
    var descNode = document.getElementById('dynamic-flavor-description');

    [mainFrame, designFrame, frontFrame].forEach(function (frame) {
      if (!frame) return;
      frame.classList.remove('flavor-glow-exotic', 'flavor-glow-fresh', 'flavor-glow-berry');
      frame.classList.add('flavor-glow-' + selected);
    });

    if (tagsNode && descNode) {
      renderFlavorTags(tagsNode, data.tags);
      descNode.textContent = data.desc || '';
      tagsNode.className = 'benefit-heading mw-flavor-tags ' + data.color;
    }

    var designLabel = document.getElementById('design-label');
    if (designLabel) {
      designLabel.classList.remove('text-primary', 'text-secondary', 'text-tertiary');
      designLabel.classList.add(data.color);
    }
    document.querySelectorAll('.design-stat-label').forEach(function (node) {
      node.classList.remove('text-primary', 'text-secondary', 'text-tertiary');
      node.classList.add(data.color);
    });

    setImageWithFade(mainImg, data.img || button.getAttribute('data-image-url'));
    setImageWithFade(designImg, data.img || button.getAttribute('data-image-url'));

    var order = ['berry', 'exotic', 'fresh'];
    var others = order.filter(function (flavor) {
      return flavor !== selected;
    });

    if (backLeft && backRight) {
      setImageWithFade(backLeft, flavorData[others[0]] && flavorData[others[0]].img);
      setImageWithFade(backRight, flavorData[others[1]] && flavorData[others[1]].img);
      if (backLeftFrame) {
        backLeftFrame.classList.remove('flavor-glow-exotic', 'flavor-glow-fresh', 'flavor-glow-berry');
        backLeftFrame.classList.add('flavor-glow-' + others[0]);
      }
      if (backRightFrame) {
        backRightFrame.classList.remove('flavor-glow-exotic', 'flavor-glow-fresh', 'flavor-glow-berry');
        backRightFrame.classList.add('flavor-glow-' + others[1]);
      }
    }

    document.querySelectorAll('[data-mw-flavor]').forEach(function (card) {
      card.classList.remove('border-primary', 'border-secondary', 'border-tertiary', 'opacity-100');
      card.classList.add('border-b-2', 'border-transparent', 'opacity-60');
      card.setAttribute('aria-pressed', 'false');
    });

    button.classList.remove('border-transparent', 'opacity-60');
    button.classList.add('opacity-100');
    button.setAttribute('aria-pressed', 'true');
    if (selected === 'exotic') button.classList.add('border-secondary');
    if (selected === 'fresh') button.classList.add('border-tertiary');
    if (selected === 'berry') button.classList.add('border-primary');

    renderNutrition(selected);
    window.requestAnimationFrame(alignCheckout);
  }

  function updateHeroStockLabels(variantId) {
    if (!productConfig) return;
    var labels = document.getElementById('hero-stock-labels');
    var shippingDate = document.getElementById('hero-stock-shipping-date');
    var bundleState = productConfig.bundleStateById && productConfig.bundleStateById[String(variantId)];
    var showLabels = Boolean(bundleState && bundleState.outOfStock);

    if (!labels) return;
    labels.classList.toggle('is-hidden', !showLabels);
    labels.setAttribute('aria-hidden', showLabels ? 'false' : 'true');

    if (shippingDate) {
      shippingDate.textContent = showLabels && bundleState.shippingText ? bundleState.shippingText : '';
      shippingDate.hidden = !(showLabels && bundleState.shippingText);
    }
  }

  function selectBundle(radio) {
    if (!radio) return;
    var variantId = radio.value;
    var selectedVariantInput = document.getElementById('selected-variant-id');
    if (selectedVariantInput) selectedVariantInput.value = variantId;

    document.querySelectorAll('.bundle-option').forEach(function (label) {
      label.classList.remove('border-primary', 'border-tertiary', 'border-secondary', 'z-10', 'is-selected');
      label.classList.add('border-outline-variant/15');
    });

    var element = document.querySelector('.bundle-option[for="' + radio.id + '"]');
    if (!element) return;
    element.classList.add('z-10', 'is-selected');
    element.classList.remove('border-outline-variant/15');

    if (element.classList.contains('hover:border-tertiary')) {
      element.classList.add('border-tertiary');
    } else if (element.classList.contains('hover:border-secondary')) {
      element.classList.add('border-secondary');
    } else {
      element.classList.add('border-primary');
    }

    updateHeroStockLabels(variantId);
    window.requestAnimationFrame(alignCheckout);
  }

  function setCheckoutError(message) {
    var errorNode = document.getElementById('checkout-error');
    if (!errorNode) return;
    errorNode.textContent = message || '';
    errorNode.classList.toggle('hidden', !message);
  }

  function createMainCheckoutToken() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return Date.now() + '-' + Math.random().toString(36).slice(2);
  }

  function getCustomBottleConfig() {
    return productConfig && productConfig.customBottle ? productConfig.customBottle : null;
  }

  function getCustomFlavorKeys() {
    var config = getCustomBottleConfig();
    if (!config) return [];
    if (Array.isArray(config.flavorOrder)) return config.flavorOrder;
    return Object.keys(config.flavors || {});
  }

  function parseQuantity(value) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function getCustomQuantities() {
    var quantities = {};
    document.querySelectorAll('[data-mw-custom-input]').forEach(function (input) {
      var flavor = input.getAttribute('data-flavor');
      if (!flavor) return;
      quantities[flavor] = Math.max(0, parseQuantity(input.value));
    });
    return quantities;
  }

  function getCustomTotal(quantities) {
    return Object.keys(quantities || {}).reduce(function (sum, flavor) {
      return sum + (Number(quantities[flavor]) || 0);
    }, 0);
  }

  function getCustomTierKey(total) {
    var config = getCustomBottleConfig();
    var min = config && Number(config.min) ? Number(config.min) : 12;
    var max = config && Number(config.max) ? Number(config.max) : 160;
    if (total < min || total > max) return '';
    if (total >= 98) return '96';
    if (total >= 48) return '48';
    if (total >= 24) return '24';
    return '12';
  }

  function getCustomVariant(flavor, tierKey) {
    var config = getCustomBottleConfig();
    var flavorConfig = config && config.flavors && config.flavors[flavor];
    return flavorConfig && flavorConfig.variants ? flavorConfig.variants[tierKey] : null;
  }

  function getCustomCheckoutBuild() {
    var config = getCustomBottleConfig();
    if (!config || !config.available) {
      return { valid: false, error: config && config.setupError ? config.setupError : '' };
    }

    var quantities = getCustomQuantities();
    var total = getCustomTotal(quantities);
    var min = Number(config.min) || 12;
    var max = Number(config.max) || 160;
    if (total < min || total > max) {
      return { valid: false, error: config.rangeError || '', total: total };
    }

    var tierKey = getCustomTierKey(total);
    var items = [];
    var flavorKeys = getCustomFlavorKeys();
    for (var i = 0; i < flavorKeys.length; i += 1) {
      var flavor = flavorKeys[i];
      var quantity = Number(quantities[flavor]) || 0;
      if (quantity <= 0) continue;
      var variant = getCustomVariant(flavor, tierKey);
      if (!variant || !variant.id) {
        return { valid: false, error: config.setupError || '', total: total };
      }
      items.push({ id: Number(variant.id), quantity: quantity });
    }

    return { valid: items.length > 0, error: items.length > 0 ? '' : config.rangeError || '', items: items, total: total, tierKey: tierKey };
  }

  async function fetchCartState() {
    return fetchJson(productConfig.routes.cart, {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
  }

  async function removeMainCheckoutLines(token) {
    var cart = await fetchCartState();
    var mainItems = (cart.items || []).filter(function (item) {
      var properties = item.properties || {};
      var isMainCheckoutItem = properties[mainCheckoutLine.sourceProperty] === 'true';
      var tokenMatches = !token || properties[mainCheckoutLine.tokenProperty] === token;
      return isMainCheckoutItem && tokenMatches;
    });
    var latestCart = cart;

    for (var i = 0; i < mainItems.length; i += 1) {
      latestCart = await changeCartLine(productConfig.routes.change, mainItems[i].key, 0);
    }

    updateHeaderCart(latestCart, {
      one: productConfig.texts.cartItemOne,
      other: productConfig.texts.cartItemOther
    }, productConfig.moneyFormat);
    return latestCart;
  }

  async function addMainCheckoutItems(items, token, extraProperties) {
    var properties = {};
    properties[mainCheckoutLine.sourceProperty] = 'true';
    properties[mainCheckoutLine.tokenProperty] = token;
    Object.keys(extraProperties || {}).forEach(function (key) {
      properties[key] = extraProperties[key];
    });

    await fetchJson(productConfig.routes.add, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: (items || []).map(function (item) {
          return {
            id: Number(item.id),
            quantity: Number(item.quantity) || 1,
            properties: properties
          };
        })
      })
    });

    updateHeaderCart(await fetchCartState(), {
      one: productConfig.texts.cartItemOne,
      other: productConfig.texts.cartItemOther
    }, productConfig.moneyFormat);
  }

  async function addMainCheckoutVariant(variantId, token) {
    return addMainCheckoutItems([{ id: variantId, quantity: 1 }], token);
  }

  async function prepareMainCheckoutCart(variantId) {
    var token = createMainCheckoutToken();
    await removeMainCheckoutLines();
    await addMainCheckoutVariant(variantId, token);
    setStoredMainCheckoutToken(token);
    return token;
  }

  async function prepareMainCustomCheckoutCart(items) {
    var token = createMainCheckoutToken();
    var extraProperties = {};
    extraProperties[customCheckoutLine.sourceProperty] = 'true';
    await removeMainCheckoutLines();
    await addMainCheckoutItems(items, token, extraProperties);
    setStoredMainCheckoutToken(token);
    return token;
  }

  function isCustomBundleOpen() {
    var form = document.getElementById('order-form');
    return Boolean(form && form.classList.contains('is-custom-open'));
  }

  function setRangeFill(range) {
    if (!range) return;
    var min = Number(range.min) || 0;
    var max = Number(range.max) || 100;
    var value = Number(range.value) || 0;
    var percent = max > min ? ((value - min) / (max - min)) * 100 : 0;
    range.style.setProperty('--mw-custom-range-fill', Math.max(0, Math.min(100, percent)) + '%');
  }

  function updateCustomRangeFills() {
    document.querySelectorAll('[data-mw-custom-range]').forEach(setRangeFill);
  }

  function setCustomFlavorQuantity(flavor, value) {
    var config = getCustomBottleConfig();
    var max = config && Number(config.maxPerFlavor) ? Number(config.maxPerFlavor) : 160;
    var nextValue = Math.max(0, Math.min(parseQuantity(value), max));
    var input = document.querySelector('[data-mw-custom-input][data-flavor="' + flavor + '"]');
    var range = document.querySelector('[data-mw-custom-range][data-flavor="' + flavor + '"]');

    if (input) input.value = String(nextValue);
    if (range) {
      range.value = String(nextValue);
      setRangeFill(range);
    }

    updateCustomSummary();
  }

  function getCustomPriceSummary(quantities, tierKey) {
    var total = getCustomTotal(quantities);
    var totalPrice = 0;
    var missingVariant = false;
    getCustomFlavorKeys().forEach(function (flavor) {
      var quantity = Number(quantities[flavor]) || 0;
      if (quantity <= 0) return;
      var variant = getCustomVariant(flavor, tierKey);
      if (!variant || variant.price === undefined || variant.price === null) {
        missingVariant = true;
        return;
      }
      totalPrice += (Number(variant.price) || 0) * quantity;
    });

    return {
      total: total,
      totalPrice: totalPrice,
      perBottle: total > 0 ? Math.round(totalPrice / total) : 0,
      missingVariant: missingVariant
    };
  }

  function updateCustomSummary() {
    var config = getCustomBottleConfig();
    var quantities = getCustomQuantities();
    var total = getCustomTotal(quantities);
    var tierKey = getCustomTierKey(total);
    var priceSummary = getCustomPriceSummary(quantities, tierKey);
    var totalBottlesNode = document.getElementById('mw-custom-total-bottles');
    var perBottleNode = document.getElementById('mw-custom-price-per-bottle');
    var totalPriceNode = document.getElementById('mw-custom-total-price');
    var errorNode = document.getElementById('mw-custom-error');
    var checkoutButton = document.getElementById('checkout-btn');
    var min = config && Number(config.min) ? Number(config.min) : 12;
    var max = config && Number(config.max) ? Number(config.max) : 160;
    var valid = Boolean(config && config.available && total >= min && total <= max && tierKey && !priceSummary.missingVariant);

    getCustomFlavorKeys().forEach(function (flavor) {
      var lineTotal = document.querySelector('[data-mw-custom-line-total="' + flavor + '"]');
      if (lineTotal) lineTotal.textContent = Number(quantities[flavor]) || 0;
    });

    if (totalBottlesNode) totalBottlesNode.textContent = String(total);
    if (perBottleNode) perBottleNode.textContent = valid ? formatMoney(priceSummary.perBottle, productConfig.moneyFormat) : '-';
    if (totalPriceNode) totalPriceNode.textContent = valid ? formatMoney(priceSummary.totalPrice, productConfig.moneyFormat) : '-';

    if (errorNode) {
      var message = '';
      if (isCustomBundleOpen()) {
        if (!config || !config.available) {
          message = config && config.setupError ? config.setupError : '';
        } else if (total < min || total > max) {
          message = config.rangeError || '';
        } else if (priceSummary.missingVariant) {
          message = config.setupError || '';
        }
      }
      errorNode.textContent = message;
      errorNode.hidden = !message;
    }

    if (checkoutButton && checkoutButton.getAttribute('aria-busy') !== 'true') {
      checkoutButton.disabled = isCustomBundleOpen() && !valid;
    }

    updateCustomRangeFills();
    return valid;
  }

  function setCustomBundleOpen(open, restoreFocus) {
    var form = document.getElementById('order-form');
    var card = document.getElementById('mwasser-custom-card');
    var openButton = document.getElementById('mw-custom-card-open');
    var closeButton = document.getElementById('mw-custom-card-close');
    var body = document.getElementById('mw-custom-card-body');
    var premade = document.getElementById('mwasser-premade-bundles');
    var separator = document.getElementById('mwasser-custom-separator');
    if (!form || !card || !openButton || !body) return;

    form.classList.toggle('is-custom-open', open);
    card.classList.toggle('is-expanded', open);
    openButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    body.hidden = !open;
    if (closeButton) closeButton.hidden = !open;
    if (premade) {
      premade.disabled = open;
      premade.setAttribute('aria-hidden', open ? 'true' : 'false');
    }
    if (separator) separator.setAttribute('aria-hidden', open ? 'true' : 'false');

    updateCustomSummary();
    window.requestAnimationFrame(alignCheckout);
    if (open) scheduleCustomBundleScroll();

    var shouldRestoreFocus = restoreFocus !== false;
    if (open && closeButton && shouldRestoreFocus) {
      closeButton.focus({ preventScroll: true });
    } else if (!open && shouldRestoreFocus) {
      openButton.focus({ preventScroll: true });
    }
  }

  function bindCustomBundleCreator() {
    var card = document.getElementById('mwasser-custom-card');
    var openButton = document.getElementById('mw-custom-card-open');
    var closeButton = document.getElementById('mw-custom-card-close');
    if (!card || !openButton || card.dataset.mwCustomBound === 'true') return;

    card.dataset.mwCustomBound = 'true';
    card.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest('button, input')) return;
      if (isCustomBundleOpen() || card.classList.contains('is-disabled')) return;
      setCustomBundleOpen(true);
    });
    openButton.addEventListener('click', function (event) {
      event.stopPropagation();
      if (card.classList.contains('is-disabled')) return;
      setCustomBundleOpen(true);
    });

    if (closeButton) {
      closeButton.addEventListener('click', function (event) {
        event.stopPropagation();
        setCustomBundleOpen(false);
      });
    }

    document.querySelectorAll('[data-mw-custom-range]').forEach(function (range) {
      setRangeFill(range);
      range.addEventListener('input', function () {
        setCustomFlavorQuantity(range.getAttribute('data-flavor'), range.value);
      });
    });

    document.querySelectorAll('[data-mw-custom-input]').forEach(function (input) {
      input.addEventListener('input', function () {
        setCustomFlavorQuantity(input.getAttribute('data-flavor'), input.value);
      });
      input.addEventListener('blur', function () {
        setCustomFlavorQuantity(input.getAttribute('data-flavor'), input.value);
      });
    });

    document.querySelectorAll('[data-mw-custom-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        var flavor = button.getAttribute('data-flavor');
        var input = document.querySelector('[data-mw-custom-input][data-flavor="' + flavor + '"]');
        var step = parseQuantity(button.getAttribute('data-step'));
        setCustomFlavorQuantity(flavor, (input ? parseQuantity(input.value) : 0) + step);
      });
    });

    updateCustomSummary();
  }

  function bindSingleBundleCheckout() {
    var orderForm = document.getElementById('order-form');
    var checkoutButton = document.getElementById('checkout-btn');
    var selectedVariantInput = document.getElementById('selected-variant-id');
    if (!orderForm || !checkoutButton || !selectedVariantInput || orderForm.dataset.mwSingleCheckoutBound === 'true') return;

    orderForm.dataset.mwSingleCheckoutBound = 'true';
    orderForm.addEventListener('submit', async function (event) {
      event.preventDefault();
      var variantId = selectedVariantInput.value;
      var originalText = checkoutButton.textContent;
      var customBuild = isCustomBundleOpen() ? getCustomCheckoutBuild() : null;

      if (customBuild && !customBuild.valid) {
        setCheckoutError(customBuild.error || productConfig.texts.checkoutError);
        updateCustomSummary();
        return;
      }

      if (!customBuild && !variantId) {
        setCheckoutError(productConfig.texts.checkoutError);
        return;
      }

      setCheckoutError('');
      checkoutButton.disabled = true;
      checkoutButton.setAttribute('aria-busy', 'true');
      checkoutButton.textContent = productConfig.texts.checkoutLoading;

      try {
        if (customBuild) {
          await prepareMainCustomCheckoutCart(customBuild.items);
        } else {
          await prepareMainCheckoutCart(variantId);
        }
        window.location.href = productConfig.routes.checkout;
      } catch (error) {
        console.error(error);
        checkoutButton.disabled = false;
        checkoutButton.removeAttribute('aria-busy');
        checkoutButton.textContent = originalText;
        setCheckoutError(productConfig.texts.checkoutError);
      }
    });
  }

  function alignCheckout() {
    var rail = document.getElementById('right-rail');
    var form = document.getElementById('order-form');
    var thumbs = document.getElementById('flavor-thumbs');
    var button = document.getElementById('checkout-btn');
    var flavorInfo = document.getElementById('flavor-info-block');
    var nutritionRow = document.getElementById('nutrition-row');
    if (!rail || !form || !thumbs || !button) return;

    if (!window.matchMedia('(min-width: 1280px)').matches) {
      form.style.marginTop = '';
      if (flavorInfo) flavorInfo.style.maxWidth = '';
      if (nutritionRow) nutritionRow.style.maxWidth = '';
      return;
    }

    if (flavorInfo) flavorInfo.style.maxWidth = '';

    if (!form.dataset.mwBaseMarginTop) {
      var previousMargin = form.style.marginTop;
      form.style.marginTop = '';
      form.dataset.mwBaseMarginTop = window.getComputedStyle(form).marginTop || '0px';
      form.style.marginTop = previousMargin;
    }

    var baseMargin = parseFloat(form.dataset.mwBaseMarginTop) || 0;
    form.style.marginTop = baseMargin + 'px';

    var thumbsBottom = thumbs.getBoundingClientRect().bottom + window.scrollY;
    var buttonBottom = button.getBoundingClientRect().bottom + window.scrollY;
    var nextMt = Math.max(baseMargin, baseMargin + Math.round(thumbsBottom - buttonBottom + 6));
    form.style.marginTop = nextMt + 'px';

    var buttonRect = button.getBoundingClientRect();
    [nutritionRow].forEach(function (block) {
      if (!block) return;
      var blockRect = block.getBoundingClientRect();
      var targetWidth = Math.floor(buttonRect.right - blockRect.left);
      var naturalWidth = block.parentElement ? Math.floor(block.parentElement.getBoundingClientRect().width) : 0;
      if (targetWidth >= 420 && (!naturalWidth || targetWidth < naturalWidth)) {
        block.style.maxWidth = targetWidth + 'px';
      } else {
        block.style.maxWidth = '';
      }
    });
  }

  var mobileFlowState = {
    thumbsPlaceholder: null,
    checkoutPlaceholder: null
  };

  var mobileCheckoutCookieState = {
    checkoutWrap: null,
    main: null,
    observer: null,
    raf: 0,
    eventsBound: false
  };

  function setupHeroBenefitBadges() {
    var frame = document.getElementById('main-product-frame');
    var chips = document.getElementById('benefit-chips');
    var svg = document.getElementById('hero-benefit-lines');
    if (!frame || !chips || !svg || heroBadgeState) return;

    var badges = Array.from(chips.querySelectorAll('[data-mw-hero-badge]'));
    if (!badges.length) return;

    var lines = badges.map(function (badge, index) {
      return svg.querySelector('[data-mw-hero-badge-line="' + index + '"]');
    });
    if (lines.some(function (line) { return !line; })) return;
    var dots = badges.map(function (badge, index) {
      return {
        start: svg.querySelector('[data-mw-hero-badge-dot="' + index + '-start"]'),
        bend: svg.querySelector('[data-mw-hero-badge-dot="' + index + '-bend"]'),
        end: svg.querySelector('[data-mw-hero-badge-dot="' + index + '-end"]')
      };
    });

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var anchorOffsets = [-112, -40, 70, -82, 18, 102];
    var badgeAngles = [35, 145, 228, 315, 58, 238];
    var bendAngles = [106, 74, 252, 286, 112, 248];
    var seeds = badges.map(function (badge, index) {
      var angle = (badgeAngles[index % badgeAngles.length]) * Math.PI / 180;
      var bendAngle = (bendAngles[index % bendAngles.length]) * Math.PI / 180;
      var speed = 5.2 + (index % 3) * 1.2;
      var bendSpeed = 7.5 + (index % 3) * 1.35;
      return {
        x: 0,
        y: 0,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        maxX: 30 + (index % 2) * 10,
        maxY: 34 + (index % 3) * 9,
        bendX: 0,
        bendY: 0,
        bendVx: Math.cos(bendAngle) * bendSpeed * 0.55,
        bendVy: Math.sin(bendAngle) * bendSpeed * 1.12,
        bendMaxX: 16 + (index % 2) * 5,
        bendMaxY: 42 + (index % 3) * 12
      };
    });

    heroBadgeState = {
      frame: frame,
      heroMask: frame.querySelector('.hero-blend-mask'),
      chips: chips,
      svg: svg,
      badges: badges,
      lines: lines,
      dots: dots,
      seeds: seeds,
      reduceMotion: reduceMotion.matches,
      anchorOffsets: anchorOffsets,
      raf: 0,
      lastTime: 0
    };
    chips.dataset.mwCalloutsReady = 'true';

    function setReducedMotion() {
      if (!heroBadgeState) return;
      heroBadgeState.reduceMotion = reduceMotion.matches;
      if (heroBadgeState.reduceMotion) {
        heroBadgeState.seeds.forEach(function (seed) {
          seed.x = 0;
          seed.y = 0;
          seed.bendX = 0;
          seed.bendY = 0;
        });
      }
      scheduleHeroBenefitBadges();
    }

    if (typeof reduceMotion.addEventListener === 'function') {
      reduceMotion.addEventListener('change', setReducedMotion);
    } else if (typeof reduceMotion.addListener === 'function') {
      reduceMotion.addListener(setReducedMotion);
    }

    window.addEventListener('resize', scheduleHeroBenefitBadges, { passive: true });
    scheduleHeroBenefitBadges();
  }

  function scheduleHeroBenefitBadges() {
    if (!heroBadgeState || heroBadgeState.raf) return;
    heroBadgeState.raf = window.requestAnimationFrame(updateHeroBenefitBadges);
  }

  function updateHeroBenefitBadges(timestamp) {
    var state = heroBadgeState;
    if (!state) return;
    state.raf = 0;
    if (!document.body.contains(state.frame)) {
      heroBadgeState = null;
      return;
    }

    var frameRect = state.frame.getBoundingClientRect();
    if (!frameRect.width || !frameRect.height) {
      scheduleHeroBenefitBadges();
      return;
    }

    state.svg.setAttribute('viewBox', '0 0 ' + frameRect.width + ' ' + frameRect.height);

    var rawDt = state.lastTime ? Math.min((timestamp - state.lastTime) / 1000, 0.06) : 0;
    state.lastTime = timestamp;
    var frameIsMobile = frameRect.width <= 560;
    var motionScale = frameIsMobile
      ? clamp((frameRect.width - 280) / 280, 0.18, 0.55)
      : 1;
    var dt = rawDt * motionScale;

    function clamp(value, min, max) {
      return Math.min(max, Math.max(min, value));
    }

    state.badges.forEach(function (badge, index) {
      var seed = state.seeds[index];
      var edgeInset = Math.min(10, Math.max(4, frameRect.width * 0.012));
      var leftRoom = Math.max(0, badge.offsetLeft - edgeInset);
      var rightRoom = Math.max(0, frameRect.width - badge.offsetLeft - badge.offsetWidth - edgeInset);
      var topRoom = Math.max(0, badge.offsetTop - edgeInset);
      var bottomRoom = Math.max(0, frameRect.height - badge.offsetTop - badge.offsetHeight - edgeInset);
      var maxLeft = Math.min(seed.maxX, leftRoom);
      var maxRight = Math.min(seed.maxX, rightRoom);
      var maxUp = Math.min(seed.maxY, topRoom);
      var maxDown = Math.min(seed.maxY, bottomRoom);
      seed.minX = -maxLeft;
      seed.maxAllowedX = maxRight;
      seed.minY = -maxUp;
      seed.maxAllowedY = maxDown;
      if (frameIsMobile) {
        var side = badge.getAttribute('data-mw-badge-side') === 'right' ? 'right' : 'left';
        var mobileLaneBounds = [
          { top: 0.04, bottom: 0.24 },
          { top: 0.36, bottom: 0.56 },
          { top: 0.72, bottom: 0.92 },
          { top: 0.11, bottom: 0.31 },
          { top: 0.39, bottom: 0.59 },
          { top: 0.72, bottom: 0.92 }
        ];
        var lane = mobileLaneBounds[index] || { top: 0.08, bottom: 0.9 };
        var laneTop = Math.round(frameRect.height * lane.top);
        var laneBottom = Math.round(frameRect.height * lane.bottom) - badge.offsetHeight;
        var laneMinY = laneTop - badge.offsetTop;
        var laneMaxY = laneBottom - badge.offsetTop;
        if (laneMaxY < laneMinY) {
          var laneMidY = (laneMinY + laneMaxY) / 2;
          laneMinY = laneMidY;
          laneMaxY = laneMidY;
        }
        seed.minY = Math.max(seed.minY, laneMinY);
        seed.maxAllowedY = Math.min(seed.maxAllowedY, laneMaxY);

        if (seed.maxAllowedY < seed.minY) {
          var midY = (seed.minY + seed.maxAllowedY) / 2;
          seed.minY = midY;
          seed.maxAllowedY = midY;
        }

        var leftCorridorRight = frameRect.width / 3;
        var rightCorridorLeft = frameRect.width * 2 / 3;
        if (side === 'left') {
          seed.maxAllowedX = Math.min(seed.maxAllowedX, leftCorridorRight - badge.offsetLeft - badge.offsetWidth);
        } else {
          seed.minX = Math.max(seed.minX, rightCorridorLeft - badge.offsetLeft);
        }

        if (seed.maxAllowedX < seed.minX) {
          var midX = (seed.minX + seed.maxAllowedX) / 2;
          seed.minX = midX;
          seed.maxAllowedX = midX;
        }
      }
      if (!state.reduceMotion) {
        seed.x += seed.vx * dt;
        seed.y += seed.vy * dt;

        if (seed.x > seed.maxAllowedX) {
          seed.x = seed.maxAllowedX;
          seed.vx = -Math.abs(seed.vx);
        } else if (seed.x < seed.minX) {
          seed.x = seed.minX;
          seed.vx = Math.abs(seed.vx);
        }

        if (seed.y > seed.maxAllowedY) {
          seed.y = seed.maxAllowedY;
          seed.vy = -Math.abs(seed.vy);
        } else if (seed.y < seed.minY) {
          seed.y = seed.minY;
          seed.vy = Math.abs(seed.vy);
        }

      }
    });

    if (!frameIsMobile) {
      for (var pass = 0; pass < 4; pass += 1) {
        for (var aIndex = 0; aIndex < state.badges.length; aIndex += 1) {
          for (var bIndex = aIndex + 1; bIndex < state.badges.length; bIndex += 1) {
            var aBadge = state.badges[aIndex];
            var bBadge = state.badges[bIndex];
            var aSeed = state.seeds[aIndex];
            var bSeed = state.seeds[bIndex];
            var gap = Math.min(18, Math.max(10, frameRect.width * 0.028));
            var aRect = {
              left: aBadge.offsetLeft + aSeed.x,
              right: aBadge.offsetLeft + aSeed.x + aBadge.offsetWidth,
              top: aBadge.offsetTop + aSeed.y,
              bottom: aBadge.offsetTop + aSeed.y + aBadge.offsetHeight
            };
            var bRect = {
              left: bBadge.offsetLeft + bSeed.x,
              right: bBadge.offsetLeft + bSeed.x + bBadge.offsetWidth,
              top: bBadge.offsetTop + bSeed.y,
              bottom: bBadge.offsetTop + bSeed.y + bBadge.offsetHeight
            };
            var overlapsX = aRect.left < bRect.right + gap && aRect.right + gap > bRect.left;
            var overlapsY = aRect.top < bRect.bottom + gap && aRect.bottom + gap > bRect.top;

            if (!overlapsX || !overlapsY) continue;

            var aCenterY = (aRect.top + aRect.bottom) / 2;
            var bCenterY = (bRect.top + bRect.bottom) / 2;
            var pushY = ((Math.min(aRect.bottom, bRect.bottom) - Math.max(aRect.top, bRect.top)) + gap) / 2;

            if (aCenterY <= bCenterY) {
              aSeed.y = clamp(aSeed.y - pushY, aSeed.minY, aSeed.maxAllowedY);
              bSeed.y = clamp(bSeed.y + pushY, bSeed.minY, bSeed.maxAllowedY);
            } else {
              aSeed.y = clamp(aSeed.y + pushY, aSeed.minY, aSeed.maxAllowedY);
              bSeed.y = clamp(bSeed.y - pushY, bSeed.minY, bSeed.maxAllowedY);
            }
          }
        }
      }
    }

    state.badges.forEach(function (badge, index) {
      var seed = state.seeds[index];
      badge.style.transform = 'translate3d(' + seed.x.toFixed(2) + 'px, ' + seed.y.toFixed(2) + 'px, 0)';
    });

    state.badges.forEach(function (badge, index) {
      var line = state.lines[index];
      var seed = state.seeds[index];
      var badgeRect = badge.getBoundingClientRect();
      var side = badge.getAttribute('data-mw-badge-side') === 'right' ? 'right' : 'left';
      var badgeLeft = badgeRect.left - frameRect.left;
      var badgeRight = badgeRect.right - frameRect.left;
      var badgeTop = badgeRect.top - frameRect.top;
      var badgeBottom = badgeRect.bottom - frameRect.top;
      var badgeCenterX = badgeLeft + (badgeRect.width / 2);
      var offsetScale = Math.min(1.15, Math.max(0.7, frameRect.height / 620));
      var bottleFloatX = 0;
      var bottleFloatY = 0;
      var hasBottleFloat = false;
      if (state.heroMask) {
        var transform = window.getComputedStyle(state.heroMask).transform;
        var transformMatch = transform && transform.match(/matrix(3d)?\(([^)]+)\)/);
        if (transformMatch) {
          var transformValues = transformMatch[2].split(',').map(function (value) {
            return parseFloat(value);
          });
          var transformX = transformMatch[1] ? transformValues[12] : transformValues[4];
          var transformY = transformMatch[1] ? transformValues[13] : transformValues[5];
          if (Number.isFinite(transformY)) {
            bottleFloatX = Number.isFinite(transformX) ? transformX : 0;
            bottleFloatY = transformY;
            hasBottleFloat = true;
          }
        }
      }
      if (!hasBottleFloat) {
        var bottleFloatPhase = ((timestamp || 0) % 5200) / 5200;
        bottleFloatY = -Math.cos(bottleFloatPhase * Math.PI * 2) * Math.min(9, Math.max(5, frameRect.height * 0.012));
      }
      function getBaseStart(targetIndex) {
        var targetBadge = state.badges[targetIndex];
        if (!targetBadge) {
          return {
            x: (frameRect.width * 0.5) + bottleFloatX,
            y: (frameRect.height * 0.5) + bottleFloatY,
            height: Math.max(16, badgeRect.height)
          };
        }
        var targetSide = targetBadge.getAttribute('data-mw-badge-side') === 'right' ? 'right' : 'left';
        var targetRect = targetBadge.getBoundingClientRect();
        return {
          x: (frameRect.width * 0.5) + (targetSide === 'right' ? frameRect.width * 0.045 : frameRect.width * -0.045) + bottleFloatX,
          y: (frameRect.height * 0.5) + ((state.anchorOffsets[targetIndex] || 0) * offsetScale) + bottleFloatY,
          height: Math.max(16, targetRect.height)
        };
      }

      function getAdjustedStart(targetIndex) {
        var baseStart = getBaseStart(targetIndex);
        if (targetIndex === 1) {
          var sugarStart = getBaseStart(0);
          var collagenStart = getBaseStart(3);
          return {
            x: sugarStart.x - (baseStart.height * 0.35),
            y: collagenStart.y - (baseStart.height * 0.35),
            height: baseStart.height
          };
        }
        if (targetIndex === 2) {
          return {
            x: baseStart.x - baseStart.height,
            y: baseStart.y + (baseStart.height * 3),
            height: baseStart.height
          };
        }
        if (targetIndex === 5) {
          var hyaluronY = baseStart.y + (baseStart.height * 4);
          if (frameIsMobile) {
            var mobileHyaluronX = clamp((frameRect.width * 0.58) + bottleFloatX, (frameRect.width / 3) + 4, (frameRect.width * 2 / 3) - 4);
            var vitaminStart = getAdjustedStart(2);
            var compactMobileY = vitaminStart.y - baseStart.height;
            var regularMobileY = (frameRect.height * 0.62) + bottleFloatY;
            var mobileHyaluronY = clamp(frameRect.width <= 390 ? compactMobileY : regularMobileY, 4, frameRect.height - 4);
            return {
              x: mobileHyaluronX,
              y: mobileHyaluronY,
              height: baseStart.height
            };
          }
          return {
            x: baseStart.x,
            y: hyaluronY,
            height: baseStart.height
          };
        }
        if (targetIndex === 4) {
          var hyaluronStart = getAdjustedStart(5);
          return {
            x: frameIsMobile ? hyaluronStart.x : hyaluronStart.x + baseStart.height,
            y: hyaluronStart.y - (baseStart.height * (frameIsMobile ? 1 : 2)),
            height: baseStart.height
          };
        }
        return baseStart;
      }

      var startPoint = getAdjustedStart(index);
      var startX = clamp(startPoint.x, 4, frameRect.width - 4);
      var startY = clamp(startPoint.y, 4, frameRect.height - 4);
      var bendRules = [
        { edge: 'end', vertical: 'below' },
        { edge: 'end', vertical: 'above' },
        { edge: 'end', vertical: 'above' },
        { edge: 'start', vertical: 'below' },
        { edge: 'threeQuarter', vertical: 'below' },
        { edge: 'start', vertical: 'above' }
      ];
      var rule = bendRules[index] || { edge: side === 'right' ? 'start' : 'end', vertical: 'above' };
      var edgeX = badgeRight;
      if (rule.edge === 'start') {
        edgeX = badgeLeft;
      } else if (rule.edge === 'threeQuarter') {
        edgeX = badgeLeft + (badgeRect.width * 0.75);
      }
      var endX = badgeCenterX;
      var endY = rule.vertical === 'below' ? badgeBottom : badgeTop;
      var verticalDirection = rule.vertical === 'below' ? 1 : -1;
      var badgeHeight = Math.max(16, badgeRect.height);
      var driftLimit = badgeHeight * 0.25;
      var time = (timestamp || 0) / 1000;
      var driftPhase = time * (frameIsMobile ? 0.38 : 0.62) + (index * 1.7);
      var sideDrift = state.reduceMotion ? 0 : Math.sin(driftPhase) * driftLimit;
      var awayDrift = state.reduceMotion ? 0 : Math.sin((driftPhase * 0.73) + 1.2) * driftLimit;
      var bendX = clamp(edgeX + sideDrift, 4, frameRect.width - 4);
      var bendY = clamp(endY + (verticalDirection * ((badgeHeight * 0.5) + awayDrift)), 4, frameRect.height - 4);
      var points = [
        startX.toFixed(1) + ',' + startY.toFixed(1),
        bendX.toFixed(1) + ',' + bendY.toFixed(1),
        endX.toFixed(1) + ',' + endY.toFixed(1)
      ].join(' ');
      var color = window.getComputedStyle(badge).color;

      line.setAttribute('points', points);
      line.style.color = color;
      line.style.stroke = color;

      var dotSet = state.dots[index] || {};
      [
        { node: dotSet.start, x: startX, y: startY, radius: 3.6 },
        { node: dotSet.bend, x: bendX, y: bendY, radius: 3.8 },
        { node: dotSet.end, x: endX, y: endY, radius: 4 }
      ].forEach(function (dot) {
        if (!dot.node) return;
        dot.node.setAttribute('cx', dot.x.toFixed(1));
        dot.node.setAttribute('cy', dot.y.toFixed(1));
        dot.node.setAttribute('r', dot.radius);
        dot.node.style.color = color;
      });
    });

    if (!state.reduceMotion) {
      scheduleHeroBenefitBadges();
    }
  }

  function getCookieBannerBottomOffset(checkoutWrap) {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    var selector = [
      '#shopify-pc__banner',
      '.shopify-pc__banner',
      '#shopify-privacy-banner',
      '.shopify-privacy-banner',
      '#onetrust-banner-sdk',
      '.ot-sdk-container',
      '.cc-window',
      '.cc-banner',
      '.cky-consent-container',
      '.cky-consent-bar',
      '.cookie-banner',
      '.cookies-banner',
      '[id*="cookie"]',
      '[class*="cookie"]',
      '[id*="Cookie"]',
      '[class*="Cookie"]',
      '[id*="consent"]',
      '[class*="consent"]',
      '[id*="Consent"]',
      '[class*="Consent"]',
      '[id*="privacy"]',
      '[class*="privacy"]'
    ].join(',');
    var offset = 0;

    document.querySelectorAll(selector).forEach(function (candidate) {
      if (!(candidate instanceof HTMLElement)) return;
      if (candidate === checkoutWrap || candidate.contains(checkoutWrap) || checkoutWrap.contains(candidate)) return;

      var styles = window.getComputedStyle(candidate);
      if (styles.display === 'none' || styles.visibility === 'hidden' || styles.opacity === '0') return;
      if (styles.position !== 'fixed' && styles.position !== 'sticky') return;

      var rect = candidate.getBoundingClientRect();
      if (rect.width < 160 || rect.height < 40) return;
      if (rect.bottom < viewportHeight - 8 || rect.top < viewportHeight * 0.35) return;

      var descriptor = [
        candidate.id,
        candidate.getAttribute('class'),
        candidate.getAttribute('aria-label'),
        candidate.getAttribute('role'),
        candidate.textContent
      ].join(' ').toLowerCase();

      if (!/(cookie|cookies|consent|privacy|gdpr|datenschutz)/.test(descriptor)) return;
      offset = Math.max(offset, Math.ceil(viewportHeight - Math.max(0, rect.top)));
    });

    return offset;
  }

  function updateMobileCheckoutCookieOffset() {
    var checkoutWrap = mobileCheckoutCookieState.checkoutWrap;
    var main = mobileCheckoutCookieState.main;
    if (!checkoutWrap || !main || (checkoutWrap.style.position !== 'fixed' && checkoutWrap.style.position !== 'absolute')) return;

    var cookieOffset = getCookieBannerBottomOffset(checkoutWrap);
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    var checkoutHeight = Math.ceil(checkoutWrap.getBoundingClientRect().height || checkoutWrap.offsetHeight || 0);
    var footer = document.querySelector('.mw-footer');
    var footerRect = footer ? footer.getBoundingClientRect() : null;
    var footerGutter = 8;
    var fixedTop = viewportHeight - cookieOffset - checkoutHeight;
    var wouldCoverFooter = footerRect && footerRect.bottom > 0 && footerRect.top < fixedTop + footerGutter;

    if (wouldCoverFooter) {
      checkoutWrap.style.position = 'absolute';
      checkoutWrap.style.top = Math.max(0, Math.round(window.scrollY + footerRect.top - checkoutHeight - footerGutter)) + 'px';
      checkoutWrap.style.bottom = '';
    } else {
      checkoutWrap.style.position = 'fixed';
      checkoutWrap.style.top = '';
      checkoutWrap.style.bottom = cookieOffset ? cookieOffset + 'px' : '0';
    }

    main.style.paddingBottom = cookieOffset ? 'calc(16rem + ' + cookieOffset + 'px)' : '16rem';
  }

  function scheduleMobileCheckoutCookieOffset() {
    if (mobileCheckoutCookieState.raf) {
      window.cancelAnimationFrame(mobileCheckoutCookieState.raf);
    }
    mobileCheckoutCookieState.raf = window.requestAnimationFrame(function () {
      mobileCheckoutCookieState.raf = 0;
      updateMobileCheckoutCookieOffset();
    });
  }

  function bindMobileCheckoutCookieOffset(checkoutWrap, main) {
    mobileCheckoutCookieState.checkoutWrap = checkoutWrap;
    mobileCheckoutCookieState.main = main;

    if (typeof MutationObserver !== 'undefined' && !mobileCheckoutCookieState.observer) {
      mobileCheckoutCookieState.observer = new MutationObserver(scheduleMobileCheckoutCookieOffset);
      mobileCheckoutCookieState.observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
      });
    }

    if (!mobileCheckoutCookieState.eventsBound) {
      mobileCheckoutCookieState.eventsBound = true;
      document.addEventListener('click', scheduleMobileCheckoutCookieOffset, true);
      window.addEventListener('scroll', scheduleMobileCheckoutCookieOffset, { passive: true });
      window.addEventListener('resize', scheduleMobileCheckoutCookieOffset, { passive: true });
    }

    scheduleMobileCheckoutCookieOffset();
  }

  function unbindMobileCheckoutCookieOffset() {
    if (mobileCheckoutCookieState.raf) {
      window.cancelAnimationFrame(mobileCheckoutCookieState.raf);
      mobileCheckoutCookieState.raf = 0;
    }

    if (mobileCheckoutCookieState.observer) {
      mobileCheckoutCookieState.observer.disconnect();
      mobileCheckoutCookieState.observer = null;
    }

    mobileCheckoutCookieState.checkoutWrap = null;
    mobileCheckoutCookieState.main = null;
  }

  function applyMobileFlow() {
    var mainGrid = document.getElementById('main-layout-grid');
    var galleryCol = document.getElementById('gallery-col');
    var rightRail = document.getElementById('right-rail');
    var thumbs = document.getElementById('flavor-thumbs');
    var form = document.getElementById('order-form');
    var title = document.getElementById('product-title-row') || document.getElementById('product-title');
    var mobileTitle = document.getElementById('mobile-product-title-row') || document.getElementById('mobile-product-title');
    var pricing = document.getElementById('product-pricing');
    var chips = document.getElementById('benefit-chips');
    var checkoutWrap = document.getElementById('checkout-cta-wrap');
    var checkoutButton = document.getElementById('checkout-btn');
    var main = document.querySelector('#mwasser-root main');
    var nutritionRow = document.getElementById('nutrition-row');
    var nutriPanel = document.getElementById('nutri-panel');
    var vitPanel = document.getElementById('vit-panel');
    if (!mainGrid || !galleryCol || !rightRail || !thumbs || !form || !checkoutWrap || !checkoutButton || !main || !nutritionRow || !nutriPanel || !vitPanel) return;

    if (!mobileFlowState.thumbsPlaceholder && thumbs.parentNode) {
      mobileFlowState.thumbsPlaceholder = document.createComment('flavor-thumbs-placeholder');
      thumbs.parentNode.insertBefore(mobileFlowState.thumbsPlaceholder, thumbs);
    }
    if (!mobileFlowState.checkoutPlaceholder && checkoutWrap.parentNode) {
      mobileFlowState.checkoutPlaceholder = document.createComment('checkout-cta-placeholder');
      checkoutWrap.parentNode.insertBefore(mobileFlowState.checkoutPlaceholder, checkoutWrap);
    }
    checkoutButton.setAttribute('form', 'order-form');

    var isMobile = window.matchMedia('(max-width: 1279px)').matches;
    var isLightTheme = (document.getElementById('mwasser-root') && document.getElementById('mwasser-root').dataset.theme) === 'theme_muskel_light';

    if (isMobile) {
      mainGrid.classList.remove('lg:grid-cols-12');
      galleryCol.classList.remove('lg:col-span-6', 'lg:sticky', 'lg:top-24');
      rightRail.classList.remove('lg:col-span-6', 'lg:flex', 'lg:flex-col');

      main.style.width = '100%';
      main.style.maxWidth = 'none';
      main.style.paddingLeft = '16px';
      main.style.paddingRight = '16px';
      mainGrid.style.gridTemplateColumns = '1fr';
      mainGrid.style.gap = '3rem';
      mainGrid.style.width = '100%';
      Array.from(mainGrid.children).forEach(function (child) {
        child.style.gridColumn = '1 / -1';
      });

      galleryCol.style.position = 'static';
      galleryCol.style.top = '';
      rightRail.style.display = 'block';
      rightRail.style.width = '100%';
      rightRail.style.maxWidth = 'none';
      rightRail.style.minWidth = '0';

      if (title) title.style.display = 'none';
      if (mobileTitle) mobileTitle.style.display = 'flex';
      if (pricing) pricing.style.display = 'flex';
      if (chips) {
        chips.style.display = chips.classList.contains('mw-hero-benefit-chips') ? 'block' : 'flex';
        chips.style.flexWrap = chips.classList.contains('mw-hero-benefit-chips') ? '' : 'nowrap';
        chips.style.gap = '';
      }

      if (!(thumbs.parentNode === form.parentNode && thumbs.previousElementSibling === form)) {
        form.insertAdjacentElement('afterend', thumbs);
      }
      form.style.width = '100%';
      form.style.maxWidth = 'none';
      form.style.minWidth = '0';
      thumbs.style.width = '100%';
      thumbs.style.maxWidth = 'none';
      thumbs.style.minWidth = '0';
      thumbs.style.display = 'grid';
      thumbs.style.gridTemplateColumns = 'repeat(3, minmax(0, 1fr))';
      thumbs.style.alignItems = 'stretch';
      thumbs.style.justifyItems = 'stretch';
      thumbs.style.gap = '0.5rem';
      thumbs.style.marginLeft = '0';
      thumbs.style.marginRight = '0';

      thumbs.querySelectorAll('.flavor-thumbnail').forEach(function (card) {
        card.style.flex = 'none';
        card.style.width = '100%';
        card.style.maxWidth = 'none';
        card.style.minWidth = '0';
      });
      thumbs.querySelectorAll('img').forEach(function (image) {
        image.style.width = '100%';
        image.style.height = 'auto';
        image.style.objectFit = 'contain';
      });

      if (checkoutWrap.parentNode !== document.body) {
        document.body.appendChild(checkoutWrap);
      }
      checkoutWrap.style.position = 'fixed';
      checkoutWrap.style.left = '0';
      checkoutWrap.style.right = '0';
      checkoutWrap.style.top = '';
      checkoutWrap.style.bottom = '0';
      checkoutWrap.style.zIndex = '60';
      checkoutWrap.style.width = '100%';
      checkoutWrap.style.boxSizing = 'border-box';
      checkoutWrap.style.paddingLeft = '16px';
      checkoutWrap.style.paddingRight = '16px';
      checkoutWrap.style.paddingBottom = '16px';
      checkoutWrap.style.background = isLightTheme
        ? 'linear-gradient(to top, #ffffff 0%, rgba(255,255,255,0.96) 55%, rgba(255,255,255,0) 100%)'
        : 'linear-gradient(to top, #000000 0%, rgba(0,0,0,0.95) 55%, rgba(0,0,0,0) 100%)';
      checkoutButton.style.maxWidth = 'none';
      main.style.paddingBottom = '16rem';
      bindMobileCheckoutCookieOffset(checkoutWrap, main);

      nutritionRow.style.display = 'grid';
      nutritionRow.style.gridTemplateColumns = '1fr';
      nutritionRow.style.gap = '2rem';
      nutriPanel.style.paddingRight = '0';
      nutriPanel.style.borderRight = '0';
      nutriPanel.style.borderBottom = isLightTheme ? '1px solid rgba(133,96,106,0.2)' : '1px solid rgba(255,255,255,0.15)';
      nutriPanel.style.paddingBottom = '2rem';
      vitPanel.style.paddingLeft = '0';
      return;
    }

    unbindMobileCheckoutCookieOffset();
    mainGrid.classList.add('lg:grid-cols-12');
    galleryCol.classList.add('lg:col-span-6', 'lg:sticky', 'lg:top-24');
    rightRail.classList.add('lg:col-span-6', 'lg:flex', 'lg:flex-col');

    main.style.width = '';
    main.style.maxWidth = '';
    main.style.paddingLeft = '';
    main.style.paddingRight = '';
    mainGrid.style.gridTemplateColumns = '';
    mainGrid.style.gap = '';
    mainGrid.style.width = '';
    Array.from(mainGrid.children).forEach(function (child) {
      child.style.gridColumn = '';
    });
    galleryCol.style.position = '';
    galleryCol.style.top = '';
    rightRail.style.display = '';
    rightRail.style.width = '';
    rightRail.style.maxWidth = '';
    rightRail.style.minWidth = '';

    if (title) title.style.display = '';
    if (mobileTitle) mobileTitle.style.display = 'none';
    if (pricing) pricing.style.display = '';
    if (chips) {
      chips.style.display = '';
      chips.style.flexWrap = '';
      chips.style.gap = '';
    }

    if (mobileFlowState.thumbsPlaceholder && mobileFlowState.thumbsPlaceholder.parentNode) {
      mobileFlowState.thumbsPlaceholder.parentNode.insertBefore(thumbs, mobileFlowState.thumbsPlaceholder);
    }
    if (checkoutWrap.parentNode !== form) {
      if (mobileFlowState.checkoutPlaceholder && mobileFlowState.checkoutPlaceholder.parentNode) {
        mobileFlowState.checkoutPlaceholder.parentNode.insertBefore(checkoutWrap, mobileFlowState.checkoutPlaceholder.nextSibling);
      } else {
        form.appendChild(checkoutWrap);
      }
    }
    form.style.width = '';
    form.style.maxWidth = '';
    form.style.minWidth = '';
    thumbs.style.width = '';
    thumbs.style.maxWidth = '';
    thumbs.style.minWidth = '';
    thumbs.style.display = '';
    thumbs.style.gridTemplateColumns = '';
    thumbs.style.alignItems = '';
    thumbs.style.justifyItems = '';
    thumbs.style.gap = '';
    thumbs.style.marginLeft = '';
    thumbs.style.marginRight = '';
    thumbs.querySelectorAll('.flavor-thumbnail').forEach(function (card) {
      card.style.flex = '';
      card.style.width = '';
      card.style.maxWidth = '';
      card.style.minWidth = '';
    });
    thumbs.querySelectorAll('img').forEach(function (image) {
      image.style.width = '';
      image.style.height = '';
      image.style.objectFit = '';
    });

    checkoutWrap.style.position = '';
    checkoutWrap.style.left = '';
    checkoutWrap.style.right = '';
    checkoutWrap.style.top = '';
    checkoutWrap.style.bottom = '';
    checkoutWrap.style.zIndex = '';
    checkoutWrap.style.width = '';
    checkoutWrap.style.boxSizing = '';
    checkoutWrap.style.paddingLeft = '';
    checkoutWrap.style.paddingRight = '';
    checkoutWrap.style.paddingBottom = '';
    checkoutWrap.style.background = '';
    checkoutButton.style.maxWidth = '';
    main.style.paddingBottom = '';
    nutritionRow.style.display = 'grid';
    nutritionRow.style.gridTemplateColumns = 'minmax(0, 1fr) minmax(0, 1fr)';
    nutritionRow.style.gap = '3rem';
    nutriPanel.style.paddingRight = '';
    nutriPanel.style.borderRight = '';
    nutriPanel.style.borderBottom = '';
    nutriPanel.style.paddingBottom = '';
    vitPanel.style.paddingLeft = '';
  }

  function positionBackgrounds() {
    var root = document.getElementById('mwasser-root');
    var arm = document.getElementById('mwasser-arm-bg');
    var chest = document.getElementById('mwasser-chest-bg');
    var designArm = document.getElementById('mwasser-design-arm-bg');
    if (!root || !arm || !chest || !designArm) return;

    var benefits = document.getElementById('benefits-section');
    if (!benefits) return;
    var rootRect = root.getBoundingClientRect();
    var isFullyMobile = window.matchMedia('(max-width: 767px)').matches;
    var mobileArmAnchor = document.getElementById('hyaluron-benefit-card');
    var armAnchor = isFullyMobile && mobileArmAnchor ? mobileArmAnchor : benefits;
    var armAnchorRect = armAnchor.getBoundingClientRect();
    var bottom = Math.max(0, Math.round(rootRect.bottom - armAnchorRect.bottom));
    root.style.setProperty('--arm-bg-bottom', bottom + 'px');

    var armRect = arm.getBoundingClientRect();
    var story = document.getElementById('story-section');
    var storyRect = story ? story.getBoundingClientRect() : armRect;
    var backHeight = Math.max(0, Math.round(rootRect.bottom - storyRect.top));
    root.style.setProperty('--back-bg-height', backHeight + 'px');

    var chestAnchor = document.getElementById('bundle-description') || document.getElementById('benefit-chips') || document.querySelector('.bundle-option');
    var chestAnchorRect = chestAnchor ? chestAnchor.getBoundingClientRect() : rootRect;
    var chestImageHalfHeight = rootRect.width * 2 * (1024 / 1536) * 0.5;
    var chestTop = window.matchMedia('(max-width: 1279px)').matches
      ? Math.round(chestAnchorRect.top - rootRect.top - chestImageHalfHeight)
      : 0;
    root.style.setProperty('--chest-bg-top', chestTop + 'px');
    var chestHeight = Math.max(0, Math.round(armRect.top - rootRect.top - chestTop));
    root.style.setProperty('--chest-bg-height', chestHeight + 'px');

    var design = document.getElementById('design-section');
    if (design) {
      var designRect = design.getBoundingClientRect();
      var isDesignStacked = window.matchMedia('(max-width: 1279px)').matches;
      var designArmOffset = Math.round(Math.min(220, Math.max(120, designRect.height * (isDesignStacked ? 0.12 : 0.18))));
      var designArmTop = Math.max(0, Math.round(designRect.top - rootRect.top - designArmOffset));
      root.style.setProperty('--design-arm-bg-top', designArmTop + 'px');
    }
  }

  function setupDesignStackObserver() {
    var designSection = document.getElementById('design-section');
    if (!designSection || designSection.dataset.mwStackObserverBound === 'true') return;
    designSection.dataset.mwStackObserverBound = 'true';

    var designFrame = document.getElementById('design-product-frame');
    function updateStack() {
      var willStack = window.matchMedia('(max-width: 1279px)').matches;
      if (!willStack) {
        if (designFrame) {
          designFrame.style.width = '';
          designFrame.style.maxWidth = '';
        }
        designSection.classList.remove('dmf-stacked');
      } else {
        designSection.classList.add('dmf-stacked');
        if (designFrame) {
          designFrame.style.width = 'min(110vw, 32rem)';
          designFrame.style.maxWidth = '110vw';
        }
      }
    }

    window.addEventListener('resize', updateStack, { passive: true });
    updateStack();
  }

  function bindProductEvents() {
    document.querySelectorAll('[data-mw-flavor]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (isCustomBundleOpen()) setCustomBundleOpen(false, false);
        switchFlavor(button);
      });
    });

    document.querySelectorAll('[data-mw-bundle]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (isCustomBundleOpen()) setCustomBundleOpen(false, false);
        selectBundle(radio);
      });
    });
  }

  function initCart() {
    if (cartInitialized) return;
    var isCartPage = window.location.pathname.indexOf('/cart') !== -1;
    var cartForm = document.querySelector('[data-mw-cart-form]');
    if (!cartForm && !isCartPage) return;
    cartInitialized = true;
    cleanupMainCheckoutLinesOnCart();
    if (!cartForm) return;

    cartForm.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.value === '') return;
        if (typeof cartForm.requestSubmit === 'function') {
          cartForm.requestSubmit();
          return;
        }
        cartForm.submit();
      });
    });
  }

  function initProduct() {
    if (productInitialized) return;
    productConfig = parseJsonScript('mwasser-product-config');
    if (!productConfig) return;
    productInitialized = true;

    bindProductEvents();
    bindCustomBundleCreator();
    renderNutrition('berry');
    var defaultRadio = document.querySelector('[data-mw-bundle]:checked') || document.querySelector('[data-mw-bundle]');
    if (defaultRadio) selectBundle(defaultRadio);
    bindSingleBundleCheckout();
    setupDesignStackObserver();
    applyMobileFlow();
    setupHeroBenefitBadges();
    alignCheckout();
    positionBackgrounds();

    var mainImage = document.getElementById('main-product-image');
    if (mainImage) {
      mainImage.addEventListener('load', function () {
        window.requestAnimationFrame(alignCheckout);
        window.requestAnimationFrame(positionBackgrounds);
      });
    }

    if (typeof ResizeObserver !== 'undefined') {
      var resizeObserver = new ResizeObserver(function (entries) {
        var shouldRepositionBackgrounds = entries.some(function (entry) {
          var id = entry.target && entry.target.id;
          return id === 'benefits-section' || id === 'story-section' || id === 'design-section';
        });

        window.requestAnimationFrame(alignCheckout);
        if (shouldRepositionBackgrounds) {
          window.requestAnimationFrame(positionBackgrounds);
        }
      });
      ['flavor-thumbs', 'order-form', 'mwasser-custom-card', 'benefits-section', 'story-section', 'design-section'].forEach(function (id) {
        var node = document.getElementById(id);
        if (node) resizeObserver.observe(node);
      });
    }
  }

  autoSelectLocale();

  document.addEventListener('DOMContentLoaded', function () {
    bindLocalizationPreference();
    bindAutoHidingHeader();
    hideHeaderForPendingHash();
    initCart();
    initProduct();
  });
  window.addEventListener('load', function () {
    bindLocalizationPreference();
    bindAutoHidingHeader();
    hideHeaderForPendingHash();
    initCart();
    initProduct();
    applyMobileFlow();
    setupHeroBenefitBadges();
    scheduleHeroBenefitBadges();
    alignCheckout();
    positionBackgrounds();
  });
  window.addEventListener('resize', function () {
    applyMobileFlow();
    setupHeroBenefitBadges();
    scheduleHeroBenefitBadges();
    alignCheckout();
    positionBackgrounds();
  });

  window.MuskelWasserTheme = {
    alignCheckout: alignCheckout,
    renderNutrition: renderNutrition,
    applyMobileFlow: applyMobileFlow
  };
})();
